import script from "./UiSearchWithList.vue?vue&type=script&setup=true&lang=js"
export * from "./UiSearchWithList.vue?vue&type=script&setup=true&lang=js"

import "./UiSearchWithList.vue?vue&type=style&index=0&id=7358e962&lang=scss"

const __exports__ = script;

export default __exports__